import React, { useState, useEffect, useRef } from "react";

import { useDispatch, useSelector, shallowEqual } from "react-redux";

import {
  Table,
  Tooltip,
  Tag,
  Form,
  Input,
  Button,
  Space,
  Modal,
  Descriptions,
  Divider,
  Statistic,
  Col,
  Popconfirm,
  Collapse,
  Select,
  DatePicker,
  InputNumber,
  TimePicker,
  Checkbox,
  message,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
  PlusOutlined,
  ExperimentOutlined,
} from "@ant-design/icons";

import "./styles.scss";

import moment from "moment";
import {
  getData,
  editItem,
  addItem,
  deleteItem,
  setItem,
  updateItem,
} from "../../../Redux/actions/crudActions";
import {
  addNewInventory,
  createLog,
  setProductInventory,
} from "../../../Redux/actions/inventoryActions";

import { errorParser } from "../../../utils/helpers";

import CreateForm from "../../Generic/CreateForm";
import ProductPriceChange from "../ProductPriceChange";
import ProductInventoryTable from "../ProductInventoryTable";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({ currentItem, onModalClose, maxProduced, idata }) => {
  const dispatch = useDispatch();
  const { user } = useSelector(
    (state) => ({
      user: state.auth.user,
    }),
    shallowEqual
  );

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const [somethingChanged, setSomethingChanged] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [data, setData] = useState([]);

  const InventoryBlueprint = [
    {
      title: "Quantity",
      key: "quantity",
      type: "number",
      rules: {
        required: true,
      },
    },
  ];

  useEffect(() => {
    calculatePortions();
  }, [idata, quantity]);

  const calculatePortions = () => {
    console.log("idata", idata);
    var newData = [];
    idata.map((item) => {
      var x =
        parseFloat(item.available_quantity) -
        parseFloat(item.quantity) * quantity;
      if (x < 0) {
        x = 0;
      }
      var newItem = {
        ...item,
        new_quantity: x,
        used_quantity: parseFloat(item.quantity) * quantity,
      };
      newData.push(newItem);
    });

    setData(newData);
  };

  const columns = [
    {
      title: "Product",
      dataIndex: "product_name",
      key: "product_name",
    },
    {
      title: "Quantity",
      dataIndex: "used_quantity",
      key: "used_quantity",
      render: (text, record, index) => {
        return text.toFixed(3);
      },
    },
    {
      title: "Unit",
      dataIndex: "unit",
      key: "unit",
    },
  ];

  const footer = () => {
    return (
      <div>
        <Button
          type="primary"
          loading={loading}
          onClick={() => {
            if (quantity > 0) {
              saveChanges();
            } else {
              message.error("Quantity can't be zero");
            }
          }}
        >
          {"Create Product"}
        </Button>
      </div>
    );
  };

  const saveChanges = () => {
    setLoading(true);

    // 1. build the flat list of all changes
    const location = user.branch;
    const flatChanges = [];
    console.log(quantity);
    // main product
    const currentProd = {
      id: currentItem.id,
      prod_name: currentItem.name,
      quantity:
        quantity > 0
          ? parseFloat(quantity) +
            parseFloat(currentItem[`${location}_count`] || 0)
          : 0,
    };

    flatChanges.push(currentProd);

    //////// CALCULATE WHAT TO SUBTRACT START
    var toSubtractData = [];

    const combinedMap = idata.reduce((acc, item) => {
      const prodId = item.product;
      // parse quantity to number
      const qty = parseFloat(item.quantity);

      if (!acc[prodId]) {
        // first time we see this product → clone item, replace quantity with Number
        acc[prodId] = {
          ...item,
          quantity: qty,
        };
      } else {
        // already seen → just add quantity
        acc[prodId].quantity += qty;
      }
      return acc;
    }, {});

    // turn the map back into an array; if you want quantity back as string, call .toString()
    const combinedIdata = Object.values(combinedMap).map((item) => ({
      ...item,
    }));

    combinedIdata.map((item) => {
      var x = parseFloat(
        parseFloat(item.available_quantity) -
          parseFloat(item.quantity) * quantity
      ).toFixed(5);
      x = parseFloat(x);
      if (x < 0) {
        x = 0;
      }

      var newItem = {
        ...item,
        new_quantity: x,
        used_quantity: parseFloat(item.quantity) * quantity,
      };
      console.log(
        "calculatePortions",
        item.product_name,
        `${parseFloat(item.available_quantity)} - ${parseFloat(
          item.quantity
        )} x ${quantity} =`,
        x
      );

      toSubtractData.push(newItem);
    });
    ///////////////// CALCULATE WHAT TO SUBTRACT END

    // ingredients
    toSubtractData.forEach((ind) => {
      flatChanges.push({
        id: ind.src.product,
        prod_name: ind.src.product_name,
        quantity: ind.new_quantity,
      });
    });

    savePart2(flatChanges);
  };

  const savePart2 = async (prods) => {
    try {
      await Promise.all(
        prods.map((indx) =>
          dispatch(
            setProductInventory(
              indx.id,
              indx.prod_name,
              indx.quantity,
              "change",
              "processed"
            )
          )
        )
      );
    } finally {
      setLoading(false);
      onModalClose("reset");
      setIsModalVisible(false);
    }
  };

  const closeModal = (action) => {
    if (!loading) {
      setIsModalVisible(false);
      if (somethingChanged) {
        onModalClose("reset");
      } else {
        onModalClose(action);
      }
      setSomethingChanged(false);
    }
  };

  return (
    <>
      <div className={"addeditbutton"}>
        <Button
          type="primary"
          icon={<ExperimentOutlined />}
          onClick={() => {
            setIsModalVisible(true);
            setLoading(false);
          }}
        >{`Make more`}</Button>
      </div>

      {isModalVisible ? (
        <Modal
          title={`Make more ${currentItem.name}`}
          visible={isModalVisible}
          footer={footer()}
          onCancel={() => {
            closeModal();
          }}
        >
          <div className="productaddedit-content">
            <Form.Item
              label={`Quantity `}
              onChange={(e) => {
                if (e.target.value < 0 || !e.target.value) {
                  setQuantity(0);
                } else if (e.target.value > maxProduced) {
                  setQuantity(maxProduced);
                } else {
                  setQuantity(parseFloat(e.target.value));
                }
              }}
            >
              <InputNumber
                type={"number"}
                min={0}
                max={maxProduced}
                style={{ width: "100%" }}
                value={quantity}
                onStep={(e) => {
                  if (e < 0) {
                    setQuantity(0);
                  } else if (e > maxProduced) {
                    setQuantity(maxProduced);
                  } else {
                    setQuantity(parseFloat(e));
                  }
                }}
                step={maxProduced < 1 ? 0.1 : 1}
              />
              <span>maximum: {maxProduced.toFixed(2)}</span>
            </Form.Item>
            <Table
              className={"ingredientsTable"}
              columns={columns}
              dataSource={data}
              pagination={false}
              width={"100%"}
            />
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default Index;
